/* *
 * The MIT License
 *
 * Copyright (c) 2014, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
'use strict';

angular.module('userdashboard', ['app.core', 'adf', 'LocalStorageModule'])
	.controller('dashboardMainCtrl', function ($rootScope, $scope, $timeout, $state, $experiments, $location, $window,
		$uibModal, localStorageService, dashboard, WEEKLY_LOG_ITEM_FIELDS, navigationService, pageTimingService,
		weeklyLogItemService, dashboardFilterInitializationService, storeService, siteService, userService) {
		var unsubscribe;
		var layoutUnsub;
		var nameUnsub;
		var saveErrorUnsub;
		var currentLayout;
		var siteChangedModal;
		function getModel(structures) {
			globalReportName = $state.params.id;
			if (globalReportName === 'byType') {
				return;
			}
			unsubscribe = storeService.subscribe(function () {
				var state = storeService.getState();
				if (state.previousAction.type === 'report-settings/ready'
						&& (state.reportSettings.reportName === globalReportName
							|| state.reportSettings.reportSettingsId === globalReportName)) {
					unsubscribe();

					if (state.reportSettings.identifierNdx && state.reportSettings.identifierNdx !== globalConfig.customer.id) {
						var sitesByCustomer = siteService.getSitesByCustomer(state.reportSettings.identifierNdx);
						if (sitesByCustomer.length) {
							var customerName = globalConfig.user.authFacts[sitesByCustomer[0].id].customerName;
							showSiteSwitchModal(state.reportSettings.reportName, customerName, state.reportSettings.identifierNdx);
						} else {
							$state.go('app.dashboard');
						}
						return;
					}
					var reportIsAuthorized = state.reportSettings.authorizationLevel !== 'NONE';
					if (state.reportSettings.userNdx === globalConfig.user.id) {
						navigationService.setFirstView({
							viewType: 'dashboards',
							baseReportName: state.reportSettings.baseReportName,
							reportSettingsId: state.reportSettings.reportSettingsId
						});
					}

					dashboardFilterInitializationService.setInitialLoad(true);
					$scope.$on('adfDashboardChanged', function (event, name, model) {
						localStorageService.set(name, model);
					});
					$scope.name = '';
					var localModel = initializeModel();
					if (reportIsAuthorized) {
						$scope.collapsible = false;
						checkDefaultState(localModel, state.reportSettings.readOnly);
						initializeWidgetLoadingMap(localModel);
						checkAndUpdateWeeklyLogItemFieldsAndTrackWidgetLoads(localModel);
						dashboardFilterInitializationService.initializeFilterList();
						initializeColumnStructure(structures, localModel);
						$scope.model = localModel;
						nameUnsub = storeService.subscribe(function () {
							var state = storeService.getState();
							var prev = state.previousAction;
							var reportName;

							if (prev.type === 'my-views/update-by-id' && prev.payload && prev.payload.reportName
								&& (prev.payload.id === globalReportName
									|| prev.payload.id === state.reportSettings.reportSettingsId)) {
								reportName = prev.payload.reportName;
							} else if ($scope.model
								&& $scope.model.reportName !== state.reportSettings.reportName) {
								reportName = state.reportSettings.reportName;
							}

							if (reportName && $scope.model && $scope.model.reportName !== reportName) {
								$timeout(function () {
									$scope.model.reportName = reportName;
								}, 0);
							}
						});
					} else {
						$timeout(function(){$scope.model = localModel;});
					}
				} else if (state.previousAction.type === 'report-settings/fetch-error') {
					unsubscribe();
					storeService.loadMyViews(globalConfig.factory.id).then(function(response) {
						var state;
						var dashboards = response.data && response.data.filter(function (view) {
							return view.viewType === 'dashboards';
						});
						if (dashboards && dashboards.length) {
							state = navigationService.getStateForDashboard(dashboards[0]);
						} else {
							state = {sref: 'app.dashboard.new-dashboard'};
						}
						$state.go(state.sref, state.params);
					});
				}
			});
			var defaultSettings = {
				mandatoryDefaultFilters: true,
				filters: [{id: 'factory', values: [globalConfig.factory.id], isMandatory: true}]
			};
			storeService.loadSavedView(globalConfig.factory.id, globalReportName, defaultSettings);
		}

		function initializeModel() {
			var localState = _.cloneDeep(storeService.getState().reportSettings);
			localState.config.column0 = localState.config.column0 || [];
			localState.config.column1 = localState.config.column1 || [];
			localState.config.column2 = localState.config.column2 || [];
			$scope.widgetIndex = 0;
			currentLayout = localState.config.layout;
			return localState;
		}

		function checkDefaultState(localModel, readOnly) {
			if (localModel.baseReportName !== 'Data Health Dashboard'
				&& localModel.baseReportName !== 'Superset'
				&& !localModel.config.column0.length
				&& !localModel.config.column1.length
				&& !localModel.config.column2.length
				&& localModel.baseReportName !== 'Performance metrics') {
				$timeout(function () {
					if (!readOnly && $scope && $scope.$$childTail) {
						$scope.$$childTail.staticBackdrop = true;
						$scope.$$childTail.addWidgetDialog();
					}
				}, 1);
			}
		}

		function initializeColumnStructure(structures, state) {
			if (state.config && Object.keys(state.config).length) {
				state.config.column0.forEach(function (widget) {
					widget.widgetIndex = $scope.widgetIndex++;
				});
				state.config.column1.forEach(function (widget) {
					widget.widgetIndex = $scope.widgetIndex++;
				});
				state.config.column2.forEach(function (widget) {
					widget.widgetIndex = $scope.widgetIndex++;
				});
				$scope.columnDefinitions = [
					{
						styleClass: structures[state.config.layout].rows[0].columns[0].styleClass,
						widgets: state.config.column0,
						columnIndex: 0
					}
				];
				if (state.config.layout.length >= 9) {
					$scope.columnDefinitions.push({
						styleClass: structures[state.config.layout].rows[0].columns[1].styleClass,
						widgets: state.config.column1,
						columnIndex: 1
					});
				}
				if (state.config.layout.length >= 10) {
					$scope.columnDefinitions.push({
						styleClass: structures[state.config.layout].rows[0].columns[2].styleClass,
						widgets: state.config.column2,
						columnIndex: 2
					});
				}
			}
			layoutUnsub = storeService.subscribe(function() {
				var newState = storeService.getState().reportSettings;
				if (currentLayout !== newState.config.layout) {
					layoutUnsub();
					currentLayout = newState.config.layout;
					$scope.model.config.layout = currentLayout;
					$scope.model = _.cloneDeep(newState);
					initializeColumnStructure(dashboard.structures, $scope.model);
				}
			});
		}

		function initializeWidgetLoadingMap(state) {
			var widgetLoadingMap = {};
			var column0 = state.config.column0 || [];
			var column1 = state.config.column1 || [];
			var column2 = state.config.column2 || [];
			widgetLoadingMap.column0 = column0.map(function(wid) {
				return true;
			});
			widgetLoadingMap.column1 = column1.map(function(wid) {
				return true;
			});
			widgetLoadingMap.column2 = column2.map(function(wid) {
				return true;
			});
			dashboardFilterInitializationService.setWidgetCreatingMap(jQuery.extend(true, {}, widgetLoadingMap));
			pageTimingService.setWidgetLoadingMap(widgetLoadingMap);
		}

		function checkAndUpdateWeeklyLogItemFieldsAndTrackWidgetLoads(state) {
			var columns = [state.config.column0 || [], state.config.column1 || [], state.config.column2 || []];
			columns.forEach(function(column) {
				column.forEach(function(widget) {
					if (WEEKLY_LOG_ITEM_FIELDS[widget.config.type]) {
						weeklyLogItemService.addField(WEEKLY_LOG_ITEM_FIELDS[widget.config.type]);
					}

					pendo.track('widgetLoad', {
						widgetType: widget.config.type,
						dashboardParentName: state.baseReportName,
						subview: getWidgetSubview(widget.config),
						activeTab: getWidgetActiveTab(widget.config)
					});
				});
			});
		}

		function getWidgetSubview(config) {
			if (_.has(config, 'settings')) {
				return config.settings['breakDown'] || config.settings['doiCalculation'] || '';
			}
			return '';
		}

		function getWidgetActiveTab(config) {
			if (_.has(config, 'settings')) {
				return config.settings['activeTab'] || '';
			}
			return '';
		}

		function init() {
			if (globalConfig.user.role === 'Supplier') {
				navigationService.goToDefaultSupplierReport('supply-chain');
			} else {
				getModel(dashboard.structures);
				if ($location.search().pendo) {
					var queryParams = $location.search();
					delete queryParams.pendo;
					$location.search(queryParams);
				}
			}
		}
		init();

		function showSiteSwitchModal(reportName, customerName, identifierNdx) {
			if (siteChangedModal) {
				siteChangedModal.close();
			}

			var modalScope = $scope.$new();
			modalScope.switch = {
				'typeOfView': 'dashboard',
				'viewName': reportName,
				'customerName': customerName
			};

			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/core/navigation/switch-site-modal.html',
				backdrop: 'static',
				keyboard: false
			};
			siteChangedModal = $uibModal.open(opts);

			modalScope.closeModal = function() {
				siteChangedModal.close();
				$state.go('app.dashboard');
			};

			modalScope.switchSite = function() {
				navigationService.getLoginSiteForCustomer(identifierNdx).then(function (data) {
					localStorageService.set('newSiteId', data.factoryNdx);
					userService.switchSite(data.factoryNdx, true);
				});
			};
		}

		$scope.$on('$destroy', function() {
			if (nameUnsub) {
				nameUnsub();
			}
			if (layoutUnsub) {
				layoutUnsub();
			}
			if (unsubscribe) {
				unsubscribe();
			}
			if (saveErrorUnsub) {
				saveErrorUnsub();
			}
		});
	});
